import * as Utils from '../libraries/Utils';
import { get } from 'lodash';
import { formatPriceZero } from '../libraries/Utils';
export const ReceiptLineDescriptionEnum = {
    Config: 'Config',
    Aggregation: 'Aggregation',
    Discount: 'Discount',
    Info: 'Info',
    Product: 'Product',
    UnselectedOption: 'UnselectedOption',
    ReturnableItem: 'ReturnableItem',
    Pant: 'Pant',
    Voucher: 'Voucher',
    SelectedOption: 'SelectedOption',
};
const discountTypeLocalization = {
    SunsetPlusForEmployees: 'Medarbejderrabat',
    SunsetPlusBasic: 'SunsetPLUS rabat',
    SunsetPlusBasicAnnual: 'SunsetPLUS rabat',
    SunsetPlusExclusive: 'SunsetPLUS rabat',
    SunsetPlusExclusiveAnnual: 'SunsetPLUS rabat',
    SunsetPlusBusiness: 'SunsetPLUS rabat',
    SunsetPlusPremium: 'SunsetPLUS rabat',
    SunsetPlusPremiumAnnual: 'SunsetPLUS rabat',
    CartDiscount: 'Rabat',
};
export const germanyReceiptLineOptions = {
    hideEachDescriptionLine: true,
    showMenuAdditionsLine: true,
    hideVatCategories: true,
};
function getTextRaw(line, i18n) {
    const { name } = line;
    const { text } = line;
    const defaultName = text || name;
    if (i18n) {
        return getEffectiveName(defaultName, line, i18n);
    }
    return defaultName;
}
const getEffectiveName = (defaultName, line, i18n) => {
    if (!i18n) {
        return defaultName;
    }
    if (defaultName === 'Pant') {
        return translate(defaultName, i18n, 'common.pant');
    }
    if ('productId' in line) {
        return translate(defaultName, i18n, `product.${line.productId}.name`);
    }
    if ('optionIndex' in line) {
        return translate(defaultName, i18n, `productConfiguration.${line.configId}.options[${line.optionIndex}].name`);
    }
    if ('productIds' in line) {
        if (line.productIds.length === 1) {
            return translate(defaultName, i18n, `product.${line.productIds[0]}.name}`);
        }
        const arrayOfTranslatedString = [];
        line.productIds.forEach((productId) => {
            arrayOfTranslatedString.push(translate('translationMissing', i18n, `product.${productId}.name`));
        });
        if (arrayOfTranslatedString.includes('translationMissing')) {
            return line;
        }
        return arrayOfTranslatedString.join(' & ');
    }
    return defaultName;
};
const translate = (defaultValue, i18n, key) => {
    if (i18n) {
        const value = get(i18n.messages[i18n.locale], key, defaultValue);
        if (value) {
            return value;
        }
    }
    return defaultValue;
};
const transformDescriptionLineToDescription = (line, i18n, options = {}, parentQuantity = 1) => {
    const getFields = (line) => {
        const fields = {};
        if (line.quantity)
            fields.quantity = line.quantity;
        if (line.price)
            fields.price = line.price;
        if (line.totalVat)
            fields.totalVat = (options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine) ? line.totalVat * parentQuantity : line.totalVat;
        if (line.vatCategoryId)
            fields.vatCategoryId = line.vatCategoryId;
        if (line.vatCategoryName)
            fields.vatCategoryName = line.vatCategoryName;
        if (line.vatReference)
            fields.vatReference = line.vatReference;
        if (line.vatRatePerMille)
            fields.vatRatePerMille = line.vatRatePerMille;
        if ('isMenuAdditionPart' in line && line.isMenuAdditionPart)
            fields.isMenuAdditionPart = line.isMenuAdditionPart;
        if ((options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine) && line.type === 'Product' && !line.isMenuAdditionPart && line.price)
            fields.shownPrice = (line.isPartOfMenu && !line.totalPrice ? line.price : line.totalPrice) * parentQuantity;
        return fields;
    };
    const indent = line.indent;
    const type = ReceiptLineDescriptionEnum;
    switch (line.type) {
        case 'Aggregation':
            return Object.assign({ text: getText(line), textRaw: getTextRaw(line), indent }, getFields(line));
        case 'Product':
            const showPriceToken = (options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine) ? false : true;
            return Object.assign(Object.assign({ text: line.isAddon
                    ? `${translate('', i18n, 'utilityComponents.addons.upgradedTo')} ${getText(line, true, i18n)}`
                    : getText((options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine) ? Object.assign(Object.assign({}, line), { quantity: parentQuantity * line.quantity }) : line, showPriceToken, i18n), textRaw: getTextRaw(line), indent }, getFields(line)), { productId: line.productId, productIds: line.productIds });
        case type.UnselectedOption: {
            const fravalgtText = `- ${getTextRaw(line, i18n)} (${translate('fravalgt', i18n, 'common.excluded')})`;
            return { text: fravalgtText, textRaw: fravalgtText, indent };
        }
        case type.SelectedOption:
            return;
        case type.ReturnableItem:
            return line;
        case type.Discount:
            return line;
        case type.Voucher:
            return line;
        default:
            throw new Error('ShouldNeverHappen');
    }
};
const transformDescriptionKioskLineToDescription = (line, parentQuantity = 1, i18n, options) => {
    const getFields = (line, includePriceToken) => {
        const fields = {};
        const isMultiplied = parentQuantity > line.quantity;
        if (line.quantity)
            fields.quantity = line.quantity;
        if (line.totalPrice && !isMultiplied) {
            fields.price = Utils.formatPriceZero(line.totalPrice);
        }
        else if (line.price) {
            fields.price = Utils.formatPriceZero(isMultiplied ? line.price * parentQuantity : line.price);
        }
        if (includePriceToken && line.totalPrice) {
            fields.includePriceToken = Boolean(includePriceToken && line.totalPrice);
        }
        if ('isMenuAdditionPart' in line && line.isMenuAdditionPart)
            fields.isMenuAdditionPart = line.isMenuAdditionPart;
        if ((options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine) && line.type === 'Product' && line.price) {
            fields.originalPrice = line.price;
            if (options.showMenuAdditionsLine) {
                if (line.isMenuAdditionPart) {
                    fields.price = Utils.formatPriceZero(0);
                }
                else {
                    fields.includePriceToken = true;
                }
            }
        }
        return fields;
    };
    const indent = line.indent;
    const type = ReceiptLineDescriptionEnum;
    switch (line.type) {
        case 'Aggregation':
            return Object.assign({ text: getTextKiosk(line), textRaw: getTextRaw(line), indent }, getFields(line));
        case 'Product':
            return Object.assign(Object.assign({ text: getTextKiosk(line, true, indent, i18n), textRaw: getTextRaw(line), indent }, getFields(line, true)), { productId: line.productId });
        case type.UnselectedOption: {
            const fravalgtText = `${getTextKiosk(line, false, indent, i18n)} (${translate('fravalgt', i18n, 'common.excluded')})`;
            return { text: fravalgtText, textRaw: fravalgtText, indent };
        }
        case type.ReturnableItem:
            return line;
        case type.Discount:
            return line;
        case type.Info:
            return line;
        case type.Voucher:
            return line;
        default:
            throw new Error('ShouldNeverHappen');
    }
};
const getText = (line, includePriceToken = false, i18n = null) => {
    const { quantity, name, totalPrice } = line;
    const defaultName = 'text' in line ? line.text : name;
    const effectiveName = getEffectiveName(defaultName, line, i18n);
    const priceToken = includePriceToken && totalPrice ? ` (+${Utils.formatPriceZero(totalPrice)})` : '';
    if (quantity === 1 || quantity === undefined) {
        return `${effectiveName}${priceToken}`;
    }
    else {
        return `${quantity} x ${effectiveName}${priceToken}`;
    }
};
const getTextKiosk = (line, includePriceToken = false, indent = 0, i18n = null) => {
    const { quantity, name } = line;
    const defaultName = 'text' in line ? `${line.text}` : `${name}`;
    const effectiveName = getEffectiveName(defaultName, line, i18n);
    const spacesAndHyphens = ' '.repeat(indent) + (indent ? '- ' : '');
    if (quantity === 1 || quantity === undefined) {
        return `${spacesAndHyphens}${effectiveName}`;
    }
    else {
        const quantityIndicator = `${quantity} x `;
        return `${spacesAndHyphens}${quantityIndicator}${effectiveName}`;
    }
};
export const mapToReceiptLineViewG5 = (receiptLines, i18n, options) => {
    return receiptLines.map((line) => {
        var _a;
        if (line.type === 'Meta') {
            return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineView', name: getText(line, false), description: [] });
        }
        const generateDescriptions = (lineDescription, skip, description = [], highlightDescription = []) => {
            if (!lineDescription || lineDescription.length === 0) {
                return {
                    description,
                    highlightDescription,
                };
            }
            return lineDescription
                .map((ld) => transformDescriptionLineToDescription(ld, i18n, options, line.quantity))
                .filter(Boolean)
                .reduce((acc, curr) => {
                if ([ReceiptLineDescriptionEnum.Voucher].includes(curr.type)) {
                    if (acc.highlightDescription.some((desc) => desc.text === curr.text)) {
                        return acc;
                    }
                    return Object.assign(Object.assign({}, acc), { highlightDescription: acc.highlightDescription.concat(curr) });
                }
                return Object.assign(Object.assign({}, acc), { description: acc.description.concat(curr) });
            }, { description, highlightDescription });
        };
        if (line.type === 'CombinatorLine') {
            return Object.assign(Object.assign(Object.assign({}, line), { generation: 5, objectType: 'ReceiptLineView', name: getText(line, true) }), generateDescriptions(line.description, true));
        }
        const subtractIntent2Prices = line.price > 0
            ? line.price
            : (line.totalPriceBefore || 0) - (((_a = line.description) === null || _a === void 0 ? void 0 : _a.reduce((sum, line) => sum + line.totalPrice, 0)) || 0);
        const discountQuantity = line === null || line === void 0 ? void 0 : line.discountQuantity;
        const isQtyOverAllowedDiscountQty = discountQuantity && line.quantity > discountQuantity;
        const derivedPrice = discountQuantity === 0 && line.totalPrice !== line.price * line.quantity
            ? Utils.formatPriceZero(line.priceBefore)
            : Utils.formatPriceZero(Math.max(line.price, subtractIntent2Prices));
        const lineText = !isQtyOverAllowedDiscountQty
            ? translate('á', i18n, 'common.each') + ' ' + derivedPrice
            : `${discountQuantity} x ${Utils.formatPriceZero(line.price)}`;
        const usesMenuPrice = 'usesMenuPrice' in line && line.usesMenuPrice;
        const newDescriptions = line.price && !(options === null || options === void 0 ? void 0 : options.hideEachDescriptionLine) && (line.quantity > 1 || usesMenuPrice)
            ? [
                {
                    text: lineText,
                    textRaw: 'á',
                    type: 'Info',
                    format: 'bold',
                },
            ]
            : [];
        if (line.type === 'Discount') {
            line.name = getOrderLineNameForDiscount(line);
        }
        if (isQtyOverAllowedDiscountQty) {
            newDescriptions.push({
                text: `${line.quantity - discountQuantity} x ${Utils.formatPriceZero(line.priceBefore)}`,
                textRaw: 'á',
                type: 'Info',
                format: 'bold',
            });
        }
        const generatedDescriptions = generateDescriptions('description' in line && line.description, false, newDescriptions);
        if (usesMenuPrice && (options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine)) {
            let hasAdditions = false;
            const sumOfAdditions = generatedDescriptions.description.reduce((sum, curr) => {
                hasAdditions = hasAdditions || curr.isMenuAdditionPart;
                return sum + (curr.isMenuAdditionPart ? curr.price : 0);
            }, 0);
            if (hasAdditions) {
                generatedDescriptions.description.push({
                    text: translate('Menu Addition', i18n, 'common.menuAddition').replace(' {{ cost }}', ''),
                    textRaw: 'Menu addition',
                    type: 'MenuAddition',
                    format: 'bold',
                    shownPrice: sumOfAdditions,
                });
            }
        }
        return Object.assign(Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineView', name: getText(line, false, i18n) }), generatedDescriptions);
    });
};
export const mapToReceiptLineKioskViewG5 = (receiptLines, i18n, options = {}) => {
    return receiptLines.map((line) => {
        if (line.type === 'Meta') {
            return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false), description: [] });
        }
        else if (line.type === 'CombinatorLine') {
            return Object.assign(Object.assign({}, line), { price: Utils.formatPriceZero(line.totalPrice), generation: 5, objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, true), description: line.description
                    .map((descLine) => transformDescriptionKioskLineToDescription(descLine, line.quantity, i18n, options))
                    .filter((line) => line !== undefined) });
        }
        const newDescriptions = [];
        if ('description' in line && line.description) {
            newDescriptions.push(...line.description
                .map((descLine) => transformDescriptionKioskLineToDescription(descLine, line.quantity, i18n, options))
                .filter((line) => line !== undefined));
        }
        const usesMenuPrice = 'usesMenuPrice' in line && line.usesMenuPrice;
        if (usesMenuPrice && (options === null || options === void 0 ? void 0 : options.showMenuAdditionsLine)) {
            line.includePriceToken = false;
            let hasAdditions = false;
            const sumOfAdditions = newDescriptions.reduce((sum, curr) => {
                hasAdditions = hasAdditions || curr.isMenuAdditionPart;
                return sum + (curr.isMenuAdditionPart ? curr.originalPrice || 0 : 0);
            }, 0);
            if (hasAdditions) {
                newDescriptions.push({
                    text: ` - ` + translate('Menu Addition', i18n, 'common.menuAddition').replace(' {{ cost }}', ''),
                    textRaw: 'Menu addition',
                    indent: 1,
                    quantity: 1,
                    includePriceToken: true,
                    price: formatPriceZero(sumOfAdditions),
                });
            }
        }
        if (line.type === 'Discount') {
            line.name = getOrderLineNameForDiscount(line);
        }
        if (line.type === 'Product') {
            const hasVoucher = line && line.description && line.description.some((desc) => desc.type === 'Voucher');
            return Object.assign(Object.assign({}, line), { price: line.totalPrice && !hasVoucher
                    ? Utils.formatPriceZero(line.totalPrice)
                    : Utils.formatPriceZero(hasVoucher && line.totalPriceBefore ? line.totalPriceBefore : line.price), objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false, 0, i18n), description: !hasVoucher
                    ? newDescriptions
                    : newDescriptions.length &&
                        newDescriptions.map((desc) => {
                            if (desc.type === 'Voucher') {
                                const price = (line.priceBefore ? line.priceBefore - line.price : line.totalPriceBefore - line.totalPriceAccum) ||
                                    0;
                                return {
                                    text: ` - ${desc.text}`,
                                    textRaw: desc.text,
                                    type: 'Product',
                                    price: `-${formatPriceZero(price)}`,
                                    quantity: 1,
                                    includePriceToken: true,
                                };
                            }
                            return desc;
                        }) });
        }
        return Object.assign(Object.assign({}, line), { objectType: 'ReceiptLineKioskView', name: getTextKiosk(line, false, 0, i18n), description: newDescriptions });
    });
};
export const isVatReferenceInReceiptLines = (receiptLines) => {
    return receiptLines.some((receiptLine) => ('vatReference' in receiptLine && receiptLine.vatReference) ||
        (receiptLine.description || []).some((description) => 'vatReference' in description && description.vatReference));
};
export const mapToVatRatesPerCategory = (receiptLines) => {
    const vatRates = [];
    receiptLines.forEach((receiptLine) => {
        const usesMenuPrice = 'usesMenuPrice' in receiptLine ? receiptLine.usesMenuPrice : false;
        if (!usesMenuPrice) {
            const vatCategoryId = 'vatCategoryId' in receiptLine && receiptLine.vatCategoryId ? receiptLine.vatCategoryId : 0;
            const vatCategoryName = 'vatCategoryName' in receiptLine && receiptLine.vatCategoryName ? receiptLine.vatCategoryName : '';
            const vatReference = 'vatReference' in receiptLine && receiptLine.vatReference ? receiptLine.vatReference : '';
            const vatRatePerMille = 'vatRatePerMille' in receiptLine && receiptLine.vatRatePerMille ? receiptLine.vatRatePerMille : 0;
            const totalVat = 'totalVat' in receiptLine && receiptLine.totalVat ? receiptLine.totalVat : 0;
            const price = receiptLine.price * (receiptLine.quantity || 1);
            if (totalVat) {
                const vatRatesIndex = vatRates.findIndex((vatRate) => vatRate.vatCategoryId === vatCategoryId);
                if (vatRatesIndex !== -1) {
                    vatRates[vatRatesIndex].totalVat += totalVat;
                    vatRates[vatRatesIndex].vats.push({ totalVat });
                    vatRates[vatRatesIndex].grossTotal += price;
                    vatRates[vatRatesIndex].grossAmounts.push(price);
                }
                else {
                    vatRates.push({
                        vatCategoryId,
                        vatCategoryName,
                        vatReference,
                        vatRatePerMille,
                        totalVat,
                        vats: [{ totalVat }],
                        grossTotal: price,
                        grossAmounts: [price],
                    });
                }
            }
        }
        if (receiptLine.description.length) {
            receiptLine.description.forEach((description) => {
                const vatCategoryId = 'vatCategoryId' in description && description.vatCategoryId ? description.vatCategoryId : 0;
                const vatCategoryName = 'vatCategoryName' in description && description.vatCategoryName ? description.vatCategoryName : '';
                const vatReference = 'vatReference' in description && description.vatReference ? description.vatReference : '';
                const vatRatePerMille = 'vatRatePerMille' in description && description.vatRatePerMille ? description.vatRatePerMille : 0;
                const totalVat = 'totalVat' in description && description.totalVat ? description.totalVat : 0;
                const price = 'shownPrice' in description && description.shownPrice
                    ? description.shownPrice
                    : 0 || ('price' in description && description.price) || 0;
                if (totalVat) {
                    const vatRatesIndex = vatRates.findIndex((vatRate) => vatRate.vatCategoryId === vatCategoryId);
                    if (vatRatesIndex !== -1) {
                        vatRates[vatRatesIndex].totalVat += totalVat;
                        vatRates[vatRatesIndex].vats.push({ totalVat });
                        vatRates[vatRatesIndex].grossTotal += price;
                        vatRates[vatRatesIndex].grossAmounts.push(price);
                    }
                    else {
                        vatRates.push({
                            vatCategoryId,
                            vatCategoryName,
                            vatReference,
                            vatRatePerMille,
                            totalVat,
                            vats: [{ totalVat }],
                            grossTotal: price,
                            grossAmounts: [price],
                        });
                    }
                }
            });
        }
    });
    return vatRates;
};
function getOrderLineNameForDiscount(line) {
    if (line.name === 'CartDiscount') {
        return discountTypeLocalization.CartDiscount;
    }
    if (discountTypeLocalization[line.tags[0]]) {
        return discountTypeLocalization[line.tags[0]];
    }
    return line.tags[0];
}
